import { Fragment, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { IonCol, IonGrid, IonRow } from "@ionic/react";

import {
  PeriodDetail,
  TimetableType,
  useTimetablePeriods,
} from "../../hooks/useTimetablePeriods";

import "./PeriodSelector.css";

interface ContainerProps extends RouteComponentProps<any> {
  timetableType: TimetableType;
  calendarDate: string;
  lessons: any[];
  onSelected: (period: PeriodDetail) => void;
  value: PeriodDetail | null | PeriodDetail[];
}

// eslint-disable-next-line react-refresh/only-export-components
const PeriodSelector: React.FC<ContainerProps> = ({
  timetableType,
  calendarDate,
  lessons,
  onSelected,
  value,
}) => {
  const [periodCoverMap, setPeriodCoverMap] = useState<any>({}); // [period: string]: boolean

  const { myPeriods, myPeriodsLoaded } = useTimetablePeriods(
    calendarDate,
    timetableType
  );

  useEffect(() => {
    // Caclulate the number of cover lessons in each period
    const pcMap: any = {};
    if (
      myPeriodsLoaded &&
      myPeriods &&
      myPeriods.length > 0 &&
      lessons &&
      lessons.length > 0
    ) {
      myPeriods.forEach((period: PeriodDetail) => {
        pcMap[period.PeriodId] = 0;
      });
      lessons.forEach((lesson: any) => {
        if (lesson?.Class?.PeriodId in pcMap) {
          if (!lesson?.Cancelled) {
            pcMap[lesson?.Class?.PeriodId]++;
          }
        }
      });
      setPeriodCoverMap(pcMap);
    }
  }, [myPeriods, lessons, myPeriodsLoaded]);

  return (
    <Fragment>
      <IonGrid>
        <IonRow>
          {myPeriods ? (
            [...myPeriods].map((period: PeriodDetail) => {
              // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
              let selected: Boolean = false;
              if (value instanceof Array) {
                selected = value.some((v) => v.PeriodId === period.PeriodId);
              } else {
                selected = value?.PeriodId === period.PeriodId;
              }
              return (
                <IonCol
                  key={period._id + timetableType}
                  onClick={() => {
                    onSelected(period);
                  }}
                  className="ion-no-padding"
                >
                  <div
                    className={
                      "period-selector " +
                      (selected
                        ? "period-selector-selected"
                        : "") + " period-selector-" + period?.TimetableType?.toLowerCase()
                    }
                  >
                    <div className={"period-selector-name"}>{period.Period}</div>

                    <div className="period-selector-covers-required">
                      {periodCoverMap[period?.PeriodId]
                        ? periodCoverMap[period?.PeriodId]
                        : "-"}
                    </div>
                  </div>
                </IonCol>);
            }
            )
          ) : (
            <div className="period-selector">
              <div className="period-selector-period">{"No Periods"}</div>
            </div>
          )}
        </IonRow>
      </IonGrid>
    </Fragment>
  );
};

export default withRouter(PeriodSelector);
